import { render, staticRenderFns } from "./MySale.vue?vue&type=template&id=5cb8cd47&scoped=true"
import script from "./MySale.vue?vue&type=script&lang=js"
export * from "./MySale.vue?vue&type=script&lang=js"
import style0 from "./MySale.vue?vue&type=style&index=0&id=5cb8cd47&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb8cd47",
  null
  
)

export default component.exports